import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { NotificationResponse } from "../types/notification";
import { apiClient } from "./client";

export interface ListNotificationsParams {
  search?: string;
  sortDir?: string;
  read?: string;
}

export async function getNotifications(params?: ListNotificationsParams): Promise<NotificationResponse[]> {
  const res = await apiClient.get<NotificationResponse[]>("/notifications", { params });
  return res.data;
}

export async function markNotificationRead(id: string): Promise<NotificationResponse> {
  const res = await apiClient.patch<NotificationResponse>(`/notifications/${id}/read`);
  return res.data;
}

export function useNotifications(params?: ListNotificationsParams) {
  return useQuery({
    queryKey: ["notifications", params],
    queryFn: () => getNotifications(params),
    refetchInterval: 5_000,
  });
}

export function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: markNotificationRead,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
}
